// IMAGE SLOTS (Kampfsport Kids Ready, German copy of Martial Arts Kids Class Ready)
// Hosted in the Impultienda store resources (Recursos) of the German store.
const STORE = 'be8548f8-664e-407a-85a3-b5975c72d454';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the German Gamma Studio cover plus
 * real pages 4 and 8 on the iMac, and the Impultienda bonus photos with their German titles typed in. Pure white background.
 */
const IMAC = RES + '1792778250860_makde-mockup-imac-f98bd219.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the German Gamma Studio book (9:16), same order as lookInside.captions: p.4, 8, 9, 10, 36, 39
 *  (pages checked clean in QC; p.12, 13, 27, 32, 38 and 40 have errors, so they are not shown). */
export const pageImages: string[] = [
  RES + '1792778319289_makde-seite-04-plan-q1-4a6cb738.webp',
  RES + '1792778352856_makde-seite-08-training-01-plan-25cfe874.webp',
  RES + '1792778296788_makde-seite-09-training-01-technik-fc4fb983.webp',
  RES + '1792778301733_makde-seite-10-training-01-uebungen-c815c005.webp',
  RES + '1792778306329_makde-seite-36-training-10-stationen-93b5c170.webp',
  RES + '1792778310492_makde-seite-39-planer-36a76b2b.webp',
];
/** 5 bonus covers (German titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792778255060_makde-bono-1-spiele-dd51c7c2.webp',
  RES + '1792778258939_makde-bono-2-guertel-102f7720.webp',
  RES + '1792778263085_makde-bono-3-eltern-a0debbc8.webp',
  RES + '1792778266456_makde-bono-4-pratzen-d33ca1a6.webp',
  RES + '1792778269829_makde-bono-5-probetraining-52e4bdd7.webp',
];
